import React from 'react';
import styled from 'styled-components';
import { ClientContractDocumentsDto } from '../../services/contractService';

// ============================================================================
// STYLED COMPONENTS - Regular folder styling (same as user folders)
// ============================================================================

const FolderItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  cursor: pointer;
  padding: 12px 8px;
  border-radius: var(--border-radius-md);
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: var(--background-secondary);
  }
`;

const FolderIconLarge = styled.div`
  font-size: 48px;
  margin-bottom: 8px;
  line-height: 1;
`;

const FolderName = styled.div`
  font-size: 12px;
  text-align: center;
  color: var(--text-primary);
  word-break: break-word;
  line-height: 1.3;
  max-width: 100%;
`;

const FolderCount = styled.div`
  font-size: 11px;
  color: var(--text-secondary);
  text-align: center;
`;

// ============================================================================
// COMPONENT PROPS
// ============================================================================

interface ContractDocumentsFolderProps {
  contractDocuments: ClientContractDocumentsDto;
  onClick: () => void;
}

// ============================================================================
// MAIN COMPONENT
// ============================================================================

const ContractDocumentsFolder: React.FC<ContractDocumentsFolderProps> = ({
  contractDocuments,
  onClick,
}) => {
  const documentCount = contractDocuments.documents?.length || 0;

  return (
    <FolderItem onClick={onClick}>
      <FolderIconLarge>📁</FolderIconLarge>
      <FolderName>מסמכי חוזה</FolderName>
      <FolderCount>({documentCount})</FolderCount>
    </FolderItem>
  );
};

export default ContractDocumentsFolder;
